import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

import { SubHeaderType } from '@/core/layouts/MainLayout'

import { VirtualList } from '../components/VirtualList'
import { useVirtualList } from '../hooks/useVirtualList'

import { appConfig } from '@/config'

export const TokenList = () => {
  const { setSubHeader } = useOutletContext<SubHeaderType>()
  const {
    data,
    refetch,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isSuccess,
  } = useVirtualList()

  useEffect(() => {
    setSubHeader(<></>)
  }, [setSubHeader])

  if (isSuccess && data?.length === 0) {
    return (
      <div className="flex flex-col w-full items-center text-center pt-3 px-3">
        <img
          src="/no-results.png"
          alt="no-results"
          className="md:max-w-96 mb-5 px-16"
        />
        <div className="text-lg font-bold mb-3">
          We couldn&apos;t find any matching {appConfig.marketName} for your
          search
        </div>
        <div>Try using different keywords or check your spelling</div>
      </div>
    )
  }

  return (
    <>
      <VirtualList
        data={data}
        refetch={refetch}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        showTableHeader={isLoading || data?.length > 0}
      />
    </>
  )
}
